import * as React from 'react';

export default (props:any) => (

    <svg
        viewBox='0 0 1000 1000'
        {...props}
    >
        <g>
            <path
                d="M916.5,10L500.1,426.4L83.5,10L10,83.5l416.4,416.4L10,916.5L83.5,990l416.5-416.4L916.5,990l73.5-73.5L573.6,499.9L990,83.5L916.5,10z" />
        </g>
    </svg>
)
